import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { appContext } from '../../util/decorators';
import { formatHeadingText } from '../../util/formatSportHeadingText';
import PageHeading from '../PageHeading.jsx';

const mapStateToProps = state => ({
  routeParams: state.routeParams,
  country: state.country,
});

@connect(mapStateToProps)
@appContext
export default class NewsFeedHeading extends React.PureComponent {
  static propTypes = {
    routeParams: React.PropTypes.object.isRequired,
    route: React.PropTypes.shape({
      name: React.PropTypes.string,
    }),
    country: React.PropTypes.string,
  };

  render() {
    const { country, routeParams, article } = this.props;

    if (_.isEmpty(routeParams)) return null;

    let subHeading;

    if (routeParams.teams) {
      const teamTags = _.get(article, 'tags.teams');
      const teamTag = _.find(teamTags, tag => (tag[country] || tag.en).slug === routeParams.teams);
      subHeading = _.get(teamTag, `${country}.name`) || _.get(teamTag, 'en.name');
    } else if (routeParams.competitions) {
      subHeading = _.get(article, `tags.competitions[0].${country}.name`) || _.get(article, `tags.competitions[0].en.name`);
      subHeading = subHeading.replace('Danmark DBU Pokalen', 'Oddset Pokalen').replace('Superligaen', '3F Superliga').replace('Danmark 1. Division', 'NordicBet Liga').replace('Dakar Rally', 'Formel 2').replace('Moto3', 'Formel 3').replace('Moto3', 'IMSA').replace('E-sport', 'eSuperliga').replace('Rio 2016', 'Tokyo 2021');
    } else if (routeParams.videoTypes) {
      const videoTypes = _.get(article, 'tags.videoTypes');
      const types = (() => {
        switch (typeof videoTypes) {
        case 'object':
          return Array.isArray(videoTypes) ? videoTypes.join(',').split(',') : [];
        case 'string':
          return videoTypes.split(',');
        default:
          return [];
        }
      })();
      const videoType = _.filter(types, v => v !== 'vce-clip' && v !== '48hclip')[0];
      subHeading = videoType ? this.context.app.t('ContentMeta.' + videoType) : '';
    } else {
      subHeading = this.context.app.t('PageHeading.news');
    }
	
    return (
        <div className="row news-feed-heading-row">
            <div className="template-item col-xs-12">
            	
                <PageHeading firstPart={formatHeadingText(country, routeParams.sports)} secondPart={subHeading} />
    
            </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/NewsFeed/NewsFeedHeading.jsx